import { c as _c } from "react/compiler-runtime";
import React from "react";
import elements from "./PointListPoint.module.scss";
export type PointListPointProps = {
  number?: number;
  layout: "left" | "top";
  heading: string;
  paragraph: string;
};
export const PointListPoint: React.FC<PointListPointProps> = t0 => {
  const $ = _c(16);
  const {
    number,
    layout,
    heading,
    paragraph
  } = t0;
  const t1 = layout === "top" ? elements.top : "";
  let t2;
  if ($[0] !== t1) {
    t2 = [elements.pointlistpoint, t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[2] !== layout || $[3] !== number) {
    t4 = number != null ? <h5 className={elements.pointlistpoint__number}>{layout === "left" ? `${number}` : `0${number}.`}</h5> : null;
    $[2] = layout;
    $[3] = number;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== heading) {
    t5 = <h5 className={elements.pointlistpoint__heading}>{heading}</h5>;
    $[5] = heading;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== paragraph) {
    t6 = <p className={elements.pointlistpoint__paragraph}>{paragraph}</p>;
    $[7] = paragraph;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t7) {
    t8 = <div className={t3}>{t4}{t7}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};